var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"681526bc72eaebbf22b7ac7d0c25da3e4a466fe9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["storefront@otovo"]={id:"681526bc72eaebbf22b7ac7d0c25da3e4a466fe9"};
      